import { gql } from '@apollo/client'

export const EDIT_VACCINATION_RECORD = gql`
  mutation EditVaccinationRecord($inputData: EditVaccinationRecordInput!) {
    editVaccinationRecord(inputData: $inputData) {
      id
    }
  }
`
